import React, { useState } from 'react';
import { FaComment } from 'react-icons/fa'; // 소셜 로그인 아이콘 예시
import { socialLoginPost } from "../network/login";
import { loginPost } from '../network/login';
import { useNavigate } from 'react-router-dom';

import { MdArrowBackIos } from "react-icons/md";
import { MY_URL } from '../client';

const LOGO_URL = 'https://i.ibb.co/PZZBzTkk/modii-logo.png';

function LoginPage() {
      const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

      const Rest_api_key='0c78bdb31f537e620585df214a9095fc' //REST API KEY
    const redirect_uri = MY_URL + '/auth' //Redirect URI
    // oauth 요청 URL
    const kakaoURL = `https://kauth.kakao.com/oauth/authorize?client_id=${Rest_api_key}&redirect_uri=${redirect_uri}&response_type=code`


  const handleLogin = async () => {
    console.log('로그인 시도:', username, password);
      const user = await loginPost(username, password)
      console.log(user)
      if(user){
            navigate('/');
      }
    // 실제 로그인 API 호출 로직을 여기에 구현합니다.
  };
  
  const handleSocialLogin = () => {
    console.log('소셜 로그인 클릭');
    // 소셜 로그인 팝업 또는 페이지 이동 로직을 여기에 구현합니다.

    const code = new URL(window.location.href).searchParams.get("code");
    window.location.href = kakaoURL;


  };

    const loginWithApple = async (e) => {
    e.preventDefault();

    console.log('sign in with apple');

    window.AppleID.auth.init({
      clientId: 'modii',
      scope: 'name',
      redirectURI: MY_URL + '/oauth',
      state: 'asdf',
      nonce: 'asdf',
      usePopup: true,
    });

    try {
      const res = await window.AppleID.auth.signIn();
      const rspon = await socialLoginPost('apple',res.authorization.code,'')
      if(rspon == 'INVALID_USERNAME')
        {
                                    const queryParams = new URLSearchParams({
                              id: 'apple',
                              socialAccountToken: res.authorization.code
                              //category: postCategory
                            }).toString();

                            // /detail 경로로 인자를 포함하여 GET 방식으로 이동
                            navigate(`/signup?${queryParams}`);
      }else{
        navigate(`/`);
      }
    } catch (error) {
      console.log(error);
    }
  };

   const goBack = () => {
    // navigate(-1)을 호출하여 이전 경로로 이동
    navigate(-1);
  };

  const handleSignup = () => {

        const queryParams = new URLSearchParams({
      id: 'username',
            socialAccountToken: '',
      //category: postCategory
    }).toString();

    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/signup?${queryParams}`);
    // 회원가입 페이지 이동 로직을 여기에 구현합니다.
  };


  return (
    <div style={styles.mobileContainer}>
      <MdArrowBackIos size="24" onClick={goBack} style={{marginTop:'20px', marginLeft : '10px'}} />
      
      {/* 1. 로고 영역 */}
      <div style={styles.logoContainer}>
        <img 
          src={LOGO_URL} 
          alt="Modii Logo" 
          style={styles.logoImage} 
        />
      </div>

      {/* 2. 로그인 폼 영역 */}
      <div style={styles.formContainer}>
        
        {/* 아이디 입력 필드 */}
        <input 
          type="text"
          placeholder="아이디를 입력해 주세요"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={styles.inputField}
        />

        {/* 비밀번호 입력 필드 */}
        <input 
          type="password"
          placeholder="비밀번호를 입력해 주세요"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.inputField}
        />
        
        {/* 로그인 버튼 (붉은색) */}
        <button 
          onClick={handleLogin}
          style={styles.loginButton}
        >
          로그인
        </button>

        {/* 아이디/비밀번호 찾기 링크 */}
        <div style={styles.forgotLinkContainer}>
            <a href="/findpw" style={styles.forgotLink}>
                아이디/비밀번호 찾기
            </a>
        </div>
      </div>
      
      {/* 3. 소셜 로그인 영역 */}
      <div style={styles.socialContainer}>
        <p style={styles.socialText}>SNS 계정으로 로그인하기</p>
        
        {/* 소셜 로그인 아이콘 (예시) */}
        <div style={{display:'flex', gap:'15px'}}>
        <button onClick={handleSocialLogin} style={styles.socialIcon}>
          <img style={{width:'50px'}} src='https://cdn.imweb.me/upload/S20210304872ba49a108a8/89a68d1e3674a.png'></img>
            {/* <FaComment size={28} color="#000" /> */}
            {/* 사진 속 노란색 원 배경은 필요에 따라 추가할 수 있습니다. */}
        </button>

                <button onClick={loginWithApple} style={styles.socialIcon}>
          <img style={{width:'50px'}} src='https://images.icon-icons.com/70/PNG/512/apple_14192.png'></img>
            {/* <FaComment size={28} color="#000" /> */}
            {/* 사진 속 노란색 원 배경은 필요에 따라 추가할 수 있습니다. */}
        </button>
        </div>


      </div>

      {/* 4. 회원가입 영역 */}
      <div style={styles.signupContainer}>
        
        {/* 회원가입 버튼 (테두리만 있는 붉은색) */}
        <button 
          onClick={handleSignup}
          style={styles.signupButton}
        >
          모디 아이디로 회원가입
        </button>
        
        {/* 하단 안내 텍스트 */}
        <p style={styles.infoText}>
          서비스 이용을 위해 회원가입 시, 본인인증이 필요합니다
        </p>
      </div>
    </div>
  );
}

// ----------------------------------------------------
// 3. 스타일 정의
// ----------------------------------------------------
const styles = {
  mobileContainer: {
    maxWidth: '420px', 
    height: '100vh', 
    margin: '0 auto',  
    padding: '0 30px', // 좌우 패딩
    display: 'flex',
    flexDirection: 'column',
   
    justifyContent: 'space-around', // 주요 섹션들을 균등하게 분배
    textAlign: 'center',
  },
  
  // 로고 영역
  logoContainer: {
    paddingTop: '90px', // 상단 여백
    flex: 1, // 상단 공간을 많이 차지하도록
    display: 'flex',
    alignItems: 'center',
    flexDirection:'column'
  },
  logoImage: {
    width: '120px',
    height: 'auto',
  },
  
  // 폼 영역
  formContainer: {
    width: '100%',
    flex: 2, // 중간 영역 공간 할당
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '10px',
  },
  inputField: {
    width: '100%',
    padding: '15px 0',
    marginBottom: '15px',
    border: 'none',
    borderBottom: '1px solid #ddd', // 하단 밑줄
    fontSize: '13px',
    outline: 'none',
    //textAlign: 'center',
  },
  loginButton: {
    width: '100%',
    padding: '15px 0',
    backgroundColor: '#FF3640', // 메인 붉은색
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
   
    cursor: 'pointer',
    marginTop: '15px',
  },
  forgotLinkContainer: {
    width: '100%',
    textAlign: 'right',
    marginTop: '15px',
    paddingRight: '5px',
  },
  forgotLink: {
    color: '#888',
    fontSize: '14px',
    textDecoration: 'none',
  },

  // 소셜 영역
  socialContainer: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '20px',
  },
  socialText: {
    color: '#888',
    fontSize: '14px',
    marginBottom: '15px',
  },
  socialIcon: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: '#fff', // 배경을 흰색으로 가정
    border: '1px solid #ddd',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    // 사진 속 노란색 원은 이 버튼의 배경이나 외부 div로 구현 가능
  },
  
  // 회원가입 영역
  signupContainer: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingBottom: '30px',
  },
  signupButton: {
    width: '100%',
    padding: '15px 0',
    backgroundColor: 'white',
    color: '#ff4d4f', // 붉은색 텍스트
    border: `2px solid #ff4d4f`, // 붉은색 테두리
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginBottom: '15px',
  },
  infoText: {
    color: '#aaa',
    fontSize: '11px',
    padding: '0 10px',
    lineHeight: 1.4,
  }
};

export default LoginPage;